
namespace GeniuzPOS.RefundReasonReport {

    @Serenity.Decorators.registerClass()
    export class ReportRefundReasonSumBillGrid extends Serenity.EntityGrid<ReportRefundReasonSumBillRow, any> {
        protected getColumnsKey() { return ReportRefundReasonSumBillColumns.columnsKey; }
        protected getDialogType() { return ReportRefundReasonSumBillDialog; }
        protected getIdProperty() { return ReportRefundReasonSumBillRow.idProperty; }
        protected getInsertPermission() { return ReportRefundReasonSumBillRow.insertPermission; }
        protected getLocalTextPrefix() { return ReportRefundReasonSumBillRow.localTextPrefix; }
        protected getService() { return ReportRefundReasonSumBillService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = super.getButtons();

             buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'refresh-button'), 1)
            //  buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)
             buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
             //buttons.push(send);


             // Add buttons import excel, pdf
             buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                 grid: this,
                 service: ReportRefundReasonSumBillService.baseUrl + '/ListExcel',
                 onViewSubmit: () => this.onViewSubmit(),
                 separator: true
             }));

             buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/QRreport/QRywcSpec#QRreport.QRyReportRefundReasonSumBill/edit/129';
                        return false;
                    },
                }
            );


            return buttons;
        }
    }
}